var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-image-selector"
  }, [_vm._t("trigger", function () {
    return [!_vm.image ? _c('button', {
      on: {
        "click": _vm.openFileSelector
      }
    }, [_vm._v("Add Photo")]) : _vm._e()];
  }, {
    "openFileSelector": _vm.openFileSelector
  }), _c('input', {
    ref: "input",
    staticClass: "s-file-input",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": function change($event) {
        return _vm.loadImage($event.target.files[0]);
      }
    }
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.popupOpened ? _c('div', {
    staticClass: "s-cropper-popup"
  }, [_c('div', {
    staticClass: "s-cropper-popup-inner"
  }, [_c('VueCropper', {
    ref: "cropper",
    staticClass: "sr-only",
    attrs: {
      "src": _vm.image,
      "aspect-ratio": _vm.freeAspectRatio ? NaN : _vm.aspectRatio,
      "initialAspectRatio": _vm.freeAspectRatio ? NaN : _vm.aspectRatio
    }
  }), !_vm.liffStyle ? _c('div', {
    staticClass: "mb-3"
  }, [_c('button', {
    staticClass: "btn btn-outline-danger btn-sm s-cancel-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("取消")]), _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cropImage
    }
  }, [_vm._v("確定")])]) : _c('div', {
    staticClass: "d-flex justify-content-between mb-3"
  }, [_c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    attrs: {
      "variant": "outline-dark",
      "block": ""
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v(" 取消 ")]), _c('SharedButton', {
    staticClass: "s-btn-bg-primary ml-2",
    attrs: {
      "variant": "primary",
      "block": ""
    },
    on: {
      "click": _vm.cropImage
    }
  }, [_vm._v(" 確定 ")])], 1), _vm._t("content"), _c('div', [_c('img', {
    attrs: {
      "id": _vm.randomId,
      "src": _vm.image
    }
  })])], 2)]) : _vm._e()])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }